module.exports = __webpack_public_path__ + "static/media/bike3b.ee76f431.jpg";